// Messages for operator/settings/Staff (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.staff.head': 'Staff & Roles — Operator',
  'operator.staff.all_settings': 'All settings',
  'operator.staff.title': 'Staff & Roles',
  'operator.staff.desc': 'Members & custom roles',
  'operator.staff.col.name': 'Name',
  'operator.staff.col.email': 'Email',
  'operator.staff.col.role': 'Role',
  'operator.staff.col.actions': 'Actions',
  'operator.staff.filter.all': 'All',
  'operator.staff.filter.unassigned': 'No role',
  'operator.staff.empty': 'No staff yet.',
  'operator.staff.deactivated': 'Deactivated ({count})',
  'operator.staff.invite': 'Invite',
  'operator.staff.edit': 'Edit',
  'operator.staff.edit_title': 'Edit staff member',
  'operator.staff.save': 'Save changes',
  'operator.staff.field.name': 'Name',
  'operator.staff.name_placeholder': 'e.g. Erin Walker',
  'operator.staff.resend': 'Resend invite',
  'operator.staff.disable': 'Disable',
  'operator.staff.enable': 'Enable',
  'operator.staff.remove': 'Remove',
  'operator.staff.confirm_remove': 'Remove {email} from staff?',
  'operator.staff.link.sent': 'One-time set-password link for',
  'operator.staff.link.share_hint': '— share it securely (email is inert until launch):',
  'operator.staff.link.copy': 'Copy link',
  'operator.staff.link.dismiss': 'Dismiss',
  'operator.staff.invite_title': 'Invite a staff member',
  'operator.staff.cancel': 'Cancel',
  'operator.staff.send_invite': 'Send invite',
  'operator.staff.field.email': 'Email',
  'operator.staff.field.role': 'Role',
  'operator.staff.invite_hint':
    'Creates an invited account and a one-time set-password link. They pick a password to activate.',
  'operator.staff.roles': 'Roles ({count})',
  'operator.staff.manage_roles': 'Manage roles',
  'operator.staff.system': 'system',
  'operator.staff.custom': 'custom',
  'operator.staff.permission': '{count} permission',
  'operator.staff.permissions': '{count} permissions',
  'operator.staff.note':
    'Roles: Owner · Admin · Operations · Read-only + custom roles composed from fine-grained permissions. Staff provisioning is invitation-only.',
}

export const zhTW = {
  'operator.staff.head': '人員與角色 — 操作員',
  'operator.staff.all_settings': '所有設定',
  'operator.staff.title': '人員與角色',
  'operator.staff.desc': '成員與自訂角色',
  'operator.staff.col.name': '名稱',
  'operator.staff.col.email': '電子郵件',
  'operator.staff.col.role': '角色',
  'operator.staff.col.actions': '操作',
  'operator.staff.filter.all': '全部',
  'operator.staff.filter.unassigned': '未指派角色',
  'operator.staff.empty': '尚無人員。',
  'operator.staff.deactivated': '已停用（{count}）',
  'operator.staff.invite': '邀請',
  'operator.staff.edit': '編輯',
  'operator.staff.edit_title': '編輯人員',
  'operator.staff.save': '儲存變更',
  'operator.staff.field.name': '名稱',
  'operator.staff.name_placeholder': '例如：Erin Walker',
  'operator.staff.resend': '重新傳送邀請',
  'operator.staff.disable': '停用',
  'operator.staff.enable': '啟用',
  'operator.staff.remove': '移除',
  'operator.staff.confirm_remove': '將 {email} 從人員中移除？',
  'operator.staff.link.sent': '一次性設定密碼連結，供',
  'operator.staff.link.share_hint': '— 請安全地分享（啟用前電子郵件無效）：',
  'operator.staff.link.copy': '複製連結',
  'operator.staff.link.dismiss': '關閉',
  'operator.staff.invite_title': '邀請人員',
  'operator.staff.cancel': '取消',
  'operator.staff.send_invite': '傳送邀請',
  'operator.staff.field.email': '電子郵件',
  'operator.staff.field.role': '角色',
  'operator.staff.invite_hint': '建立受邀帳戶與一次性設定密碼連結。對方設定密碼後即可啟用。',
  'operator.staff.roles': '角色（{count}）',
  'operator.staff.manage_roles': '管理角色',
  'operator.staff.system': '系統',
  'operator.staff.custom': '自訂',
  'operator.staff.permission': '{count} 項權限',
  'operator.staff.permissions': '{count} 項權限',
  'operator.staff.note':
    '角色：擁有者 · 管理員 · 營運 · 唯讀 + 由細項權限組成的自訂角色。人員配置僅限邀請制。',
}
